/**
 * Serialises the current filter array and writes it to localStorage.
 *
 * @param {Array<object>} currentFilters - Current `anotherFilters` array from TableService.
 */
export const saveFilterOnLocalStorage = (currentFilters) => {
  const newState = { filters: currentFilters };
  localStorage.setItem("qualificationsPageState", JSON.stringify(newState));
};

/**
 * Resolves an initial display value for a ResourceSelectLazyLoading input from
 * a persisted filter ID (or array of IDs).
 *
 * @param {number|Array<number>|undefined} valueData - Persisted filter value(s).
 * @param {Array<{value, text}>} staticOptions - Hard-coded option list.
 * @param {Array<{id, name}>} apiOptions - Dynamically fetched option records.
 * @returns {Array<{value, text}>|undefined} Pre-populated select values, or undefined.
 */
export const prepopulateFilter = (valueData, staticOptions, apiOptions = []) => {
  if (!valueData) return undefined;

  const value = Array.isArray(valueData) ? valueData : [valueData];
  const transformedApiOptions = apiOptions.map((option) => ({ value: option.id, text: option.name }));
  const allOptions = [...staticOptions, ...transformedApiOptions];

  return value.map((id) => ({
    value: id,
    text: allOptions.find((option) => option.value === id)?.text || "Unknown"
  }));
};

/**
 * Derives all named filter values from the persisted `anotherFilters` array in localStorage.
 *
 * @param {object|undefined} localStorageTableFilters - Persisted filter state from localStorage.
 * @returns {object} An object with one key per filter name.
 */
export const deriveQualificationFilters = (localStorageTableFilters) => {
  const filters = localStorageTableFilters?.anotherFilters;
  return {
    contractFilter: filters?.find((item) => item.nameKey === "validContract"),
    statusFilter: filters?.find((item) => item.nameKey === "qualificationStatus"),
    employeeStatusFilter: filters?.find((item) => item.nameKey === "employeeStatusIds"),
    branchFilter: filters?.find((item) => item.nameKey === "branchId"),
    departmentFilter: filters?.find((item) => item.nameKey === "departmentId"),
    areaFilter: filters?.find((item) => item.nameKey === "areaId"),
    jobTitleFilter: filters?.find((item) => item.nameKey === "jobTitleIds"),
    dateFilter: filters?.find((item) => item.nameKey === "dateFilter")
  };
};
